// Google Translate (and similar browser tools) rewrite text nodes in place, which leaves React
// holding stale DOM references. React then calls removeChild/insertBefore against a node that is
// no longer a child and throws NotFoundError, crashing the whole app. Making these two methods
// no-op when the node isn't actually a child lets translation keep working without the crash.
// https://github.com/facebook/react/issues/11538
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child;
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, child: Node | null): T {
    if (child && child.parentNode !== this) return node;
    return originalInsertBefore.call(this, node, child) as T;
  };
}
